// src/pages/stores/StoreDetails.js
import React from 'react';
import { useParams } from 'react-router-dom';

export default function StoreDetails() {
    const { storeId } = useParams();
    return (
        <div>
            <h2>Store Details: {storeId}</h2>
            <p>Mirror of ShopDetails with store endpoints (approve, delete, reviews, edit coordinates).</p>
        </div>
    );
}
